import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { ToggleGroupControlOptionBase } from '../toggle-group-control-option-base';
import Icon from '../../icon';
export default function ToggleGroupControlOptionIcon(props) {
  const {
    icon,
    ...restProps
  } = props;
  return createElement(ToggleGroupControlOptionBase, restProps, createElement(Icon, {
    icon: icon
  }));
}
/**
 * `ToggleGroupControlOptionIcon` is a form component which is meant to be used as a
 * child of `ToggleGroupControl` and displays an icon.
 *
 * @example
 * ```jsx
 *
 * import {
 *	__experimentalToggleGroupControl as ToggleGroupControl,
 *	__experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
 * from '@wordpress/components';
 * import { formatLowercase, formatUppercase } from '@wordpress/icons';
 *
 * function Example() {
 *	return (
 *		<ToggleGroupControl label="my label" value="vertical" isBlock>
 *			<ToggleGroupControlOptionIcon
 *				value="uppercase"
 *				icon={ formatUppercase }
 *			/>
 *			<ToggleGroupControlOptionIcon
 *				value="lowercase"
 *				icon={ formatLowercase }
 *			/>
 *		</ToggleGroupControl>
 *	);
 * }
 ** ```
 */
//# sourceMappingURL=component.js.map